import { AuthenticationContext } from './model/authentication-context';

export class SetAuthenticationContext {
  static readonly type = '[AuthContext] Set authentication context';
  constructor(public authenticationContext: AuthenticationContext) {}
}
